import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon } from 'lucide-react';
import { landingBImages } from '../../data/landingBVisual';
import { IdentityCredential } from './IdentityCredential';

/**
 * The human story panel: one photograph running to the edge, the credential
 * overlapping it, and a short editorial statement. It is the quietest section
 * on the page on purpose — it sits between two dense ones.
 */
export function MeetCampus() {
  return <section className="bg-[#faf8f3]" data-id="element-2644" data-mp="38vk845yqjhjg">
      <div className="grid lg:grid-cols-[minmax(0,1.05fr)_minmax(0,0.95fr)]" data-id="element-2645" data-mp="38uiwo0dt4t17">
        <div className="relative" data-id="element-2646" data-mp="3mnia7wu14d64">
          <img src={landingBImages.meetCampus} alt="A student sitting at a table indoors, using Campuzon on his phone" loading="lazy" decoding="async" className="h-72 w-full object-cover sm:h-96 lg:h-full lg:min-h-[26rem]" data-id="element-2647" data-mp="3mlnr8o2biv4o" />
          <IdentityCredential className="absolute bottom-4 right-4 w-64 sm:bottom-6 sm:right-6 lg:-right-16 lg:bottom-10 lg:w-72" data-id="element-2648" data-mp="3rnczxx22iwpl" />
        </div>

        <div className="flex items-center px-4 py-14 sm:px-8 lg:py-20 lg:pl-24" data-id="element-2649" data-mp="1vxyxx53gv3k8">
          <div className="max-w-md" data-id="element-2650" data-mp="1w031flxge0jz">
            <p className="text-caption font-semibold uppercase tracking-[0.16em] text-brand-800" data-id="element-2651" data-mp="1zz2exux935n1">
              Meet your campus
            </p>
            <h2 className="mt-4 text-h1 font-bold leading-[1.1] tracking-tight text-ink" data-id="element-2652" data-mp="25084jjvm6csc">
              Meet your campus,
              <br data-id="element-2653" data-mp="29vx9y3ubenwk" />
              differently.
            </h2>
            <p className="mt-5 text-body leading-relaxed text-ink-muted" data-id="element-2654" data-mp="2evjmeb2bk04b">
              From your timetable in the morning to events after class, Campuzon keeps the
              experiences that matter within reach.
            </p>
            <Link to="/identity" className="group mt-6 inline-flex min-h-touch items-center gap-2 text-body font-semibold text-brand-800" data-id="element-2655" data-mp="2nqzdikbow167">
              Learn more about Campuzon
              <ArrowRightIcon aria-hidden className="h-4 w-4 transition-transform duration-150 ease-out group-hover:translate-x-1" data-id="element-2656" data-mp="xktf0t5hx9mv" />
            </Link>
          </div>
        </div>
      </div>
    </section>;
}